import axios from './financeiroApi';

const PATH = '/api/v1/backend/boleto';

const getParams = (params) => {
  const newParams = {
    ...params,
    mesCompetencia: params?.mesCompetencia?.format('YYYY-MM-DD'),
    dataVencimento: params?.dataVencimento?.format('YYYY-MM-DD'),
    dataRecebimento: params?.dataRecebimento?.format('YYYY-MM-DD'),
  };

  return newParams;
};

export default {
  gerarRemessa: (filtro) => {
    return axios.post(`${PATH}/gerar-remessa`, filtro);
  },

  processarArquivoRetorno: (arquivoRetorno, uuidLeitura) => {
    return axios.post(`${PATH}/retorno/${uuidLeitura}`, arquivoRetorno, {
      headers: {
        'Content-Type': 'multipart/form-data',
        type: 'formData',
      },
    });
  },

  buscarHistorico: (filtro) => {
    const {
      dataArquivoInicio,
      dataArquivoFim,
      nossoNumero,
      dataVencimentoInicio,
      dataVencimentoFim,
      contaId,
      page = 0,
      size = 15,
      sort,
    } = filtro;
    return axios.get(`${PATH}/buscar-historico-remessa`, {
      params: {
        dataArquivoInicio,
        dataArquivoFim,
        nossoNumero,
        dataVencimentoInicio,
        dataVencimentoFim,
        contaId,
        page,
        size,
        sort,
      },
    });
  },

  baixarArquivoRemessa: (uuidArquivo) => {
    return axios.get(`${PATH}/baixar-arquivo-remessa/${uuidArquivo}`);
  },

  buscarErrosBoleto: (receitaId) => {
    return axios({
      url: `${PATH}/partner-bank/buscar-erros-boleto/${receitaId}`,
      method: 'GET',
      responseType: 'text',
    });
  },

  reenviarBoleto: (receitaId) => {
    return axios.post(`${PATH}/partner-bank/reenviar/${receitaId}`);
  },

  buscarUuidsCobranca: (filtro) => {
    return axios.get(`${PATH}/buscar-uuids-cobranca`, { params: getParams(filtro) });
  },

  existemBoletosRemessaPendente: () => {
    return axios.get(`${PATH}/existem-boletos-remessa-pendente`);
  },
};
